// import Vue from 'vue'
import { mapState,mapGetters } from 'vuex'

// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods
const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      primaryColor: state => state.app.color,
      colorWeak: state => state.app.weak,
      fixedHeader: state => state.app.fixedHeader,
      fixSiderbar: state => state.app.fixSiderbar,
      contentWidth: state => state.app.contentWidth,
      autoHideHeader: state => state.app.autoHideHeader,
      showTabMenu: state => state.app.showTabMenu,
      sidebarOpened: state => state.app.sidebar.opened,

      //accounts
      currentCustInfo: state => state.accounts.currentCustInfo,
      condition:state => state.accounts.condition,
      trackRecordCondition: state => state.accounts.trackRecordCondition,
      ESPCustInfo: state => state.accounts.ESPCustInfo,

      //handout
      list: state => state.handout.list,
      listNum: state => state.handout.listNum,
      where: state => state.handout.where,
      cacheData: state => state.handout.cacheData,
      perNum: state => state.handout.perNum,
      current: state => state.handout.current,
      handoutSuccess: state => state.handout.handoutSuccess,
      handoutResult: state => state.handout.handoutResult
    }),
  },
  methods: {
    isTopmenu () {
      return this.layoutMode === 'topmenu'
    },
    isSideMenu () {
      return !this.isTopmenu()
    }
  }
}
const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device,
    })
  },
  methods: {
    isMobile () {
      return this.device === 'mobile'
    },
    isDesktop () {
      return this.device === 'desktop'
    }
  }
}

export { mixin, mixinDevice }


// WEBPACK FOOTER //
// ./src/utils/mixin.js